import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core'
import moment from 'moment'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'

@Component({
  selector: 'app-check-in-status-bar',
  templateUrl: './check-in-status-bar.component.html',
  styleUrls: ['./check-in-status-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CheckInStatusBarComponent implements OnInit, OnChanges {
  @Input() inquiry: Inquiry

  @HostBinding('class.pending') get status() {
    return this.inquiry.checkInStatus === 'pending'
  }

  @HostBinding('class.checked-in') get checkedIn() {
    return this.inquiry.checkInStatus === 'checked-in'
  }

  @HostBinding('class.checked-out') get checkedOut() {
    return this.inquiry.checkInStatus === 'checked-out'
  }

  percentage = '50%'

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.refresh()
  }

  refresh() {
    if (this.inquiry.guestArrive > moment.utc().unix()) {
      this.percentage = `0%`
    } else {
      const totalStayInNights = Math.round((this.inquiry.guestDepart - this.inquiry.guestArrive) / (60 * 60 * 24))
      const daysLeft = Math.round((this.inquiry.guestDepart - moment().unix()) / (60 * 60 * 24))
      this.percentage = `${(daysLeft / totalStayInNights) * 100}%`
    }
  }
}
